export default class Action<T> {
  private earlyDelegates: ((data: T) => void)[] = []
  private delegates: ((data: T) => void)[] = []
  private once: ((data: T) => void)[] = []

  addEarly(delegate: (data: T) => void): Action<T> {
    if (this.earlyDelegates.find(d => d === delegate) === undefined) {
      this.earlyDelegates.push(delegate)
    }
    return this
  }

  add(delegate: (data: T) => void): Action<T> {
    if (this.delegates.find(d => d === delegate) === undefined) {
      this.delegates.push(delegate)
    }
    return this
  }

  addOnce(delegate: (data: T) => void) {
    if (this.once.find(d => d === delegate) === undefined) {
      this.once.push(delegate)
    }
    return this
  }

  remove(delegate: (data: T) => void) {
    let i = this.earlyDelegates.findIndex(d => d === delegate)
    if (i !== -1) {
      this.earlyDelegates.splice(i, 1)
    }

    i = this.delegates.findIndex(d => d === delegate)
    if (i !== -1) {
      this.delegates.splice(i, 1)
    }

    i = this.once.findIndex(d => d === delegate)
    if (i !== -1) {
      this.once.splice(i, 1)
    }
  }

  removeAll() {
    this.earlyDelegates.length = 0
    this.delegates.length = 0
    this.once.length = 0
  }

  invoke(data: T) {
    this.earlyDelegates.forEach(delegate => {
      delegate(data)
    })

    this.delegates.forEach(delegate => {
      delegate(data)
    })

    if (this.once.length > 0) {
      this.once.forEach(delegate => {
        delegate(data)
      })
      this.once.length = 0
    }
  }
}
